import { MethodDescription } from '../method-description';

export const FacebookLoginMethodDescription = new MethodDescription();

FacebookLoginMethodDescription.name = 'facebookLogin';
FacebookLoginMethodDescription.fields = [
	'fbToken',
];
FacebookLoginMethodDescription.usesToken = false;
